module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("6yCxg"))).then(() => parcelRequire('1iHdE'));